import { FormControl, MenuItem, Select } from "@mui/material";
import useUpdateDailyFormWorkOrderStatus from "hooks/fleet/useUpdateDailyFormWorkOrderStatus";
import { useCallback } from "react";
import { DailyFormIssueStatus } from "generated/graphql";
import { workOrderStatusOptions, WorkOrderStatusValue } from "modules/fleet/workOrderStatusOptions";

interface WorkOrderStatusCellProps {
  workOrderId: string;
  currentStatus: DailyFormIssueStatus;
}

export default function WorkOrderStatusCell({
  workOrderId,
  currentStatus,
}: WorkOrderStatusCellProps) {
  const [updateStatus, { loading }] = useUpdateDailyFormWorkOrderStatus();
  const statusOptions = workOrderStatusOptions;

  const handleStatusChange = useCallback(
    async (newStatus: WorkOrderStatusValue) => {
      if (newStatus !== currentStatus) {
        await updateStatus({
          variables: {
            input: {
              id: workOrderId,
              status: newStatus,
            },
          },
        });
      }
    },
    [currentStatus, updateStatus, workOrderId]
  );

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 120,
        "& .MuiSelect-select": {
          padding: "6px 8px",
          fontSize: "0.75rem",
        },
      }}
    >
      <Select
        value={currentStatus}
        onChange={(e) => handleStatusChange(e.target.value as WorkOrderStatusValue)}
        disabled={loading}
        variant="outlined"
        size="small"
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
